import React, { useEffect, useState } from 'react';
import Select from 'react-select';
// import DatePicker from 'react-datepicker';
import DatePicker from 'react-date-picker';
// import 'react-datepicker/dist/react-datepicker.css';
import '../../style/editablegrid.css';
import SelectSearch, { fuzzySearch } from "react-select-search";
import "../../style/select-search.css";
import configData from '../../configData.json';
import moment from 'moment';
import { formatInputDate, toLocalDate } from '../Utlities';

export default function AccBusinessReview({ sccData, onUpdateGridData, selectedCust, onDeleteRows }) {
    const [gridData, setGridData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [typeOptions, settypeOptions] = useState([]);
    const [bussreviewOptions, setBussreviewOptions] = useState([]);
    const [frequencyOptions, setFrequencyOptions] = useState([]);
    const [rankingOptions, setRankingOptions] = useState([]);
    const [newbusinessOptions, setNewBusinessOptions] = useState([]);
    const [cust, setCust] = useState(0);

    useEffect(() => {
        // debugger;
        setCust(selectedCust);
        if (Array.isArray(sccData)) {
            // debugger;
            const filteredNvisionServices = sccData.filter(
                service => service.serviceType === "BR"
            );
             // Map the filtered services
             const updatedNvisionServices = filteredNvisionServices.map(service => ({
                ...service,
                lastReviewDateValue : toLocalDate(service.lastReviewDate),
                nextReviewDateValue : toLocalDate(service.nextReviewDate)
            }));
            setGridData(updatedNvisionServices);
        } else {
            setGridData([]);
        }
        // LoadServiceCodes();
        LoadBusiessReviewCodes();
        LoadFrequency();
        LoadCustomerStatisfactionRanking();
        LoadNewBusinessOppurtunities();
    }, [sccData]);


    useEffect(() => {
        // console.log('Child')
        // console.log('-------')
        // console.log(gridData);
        onUpdateGridData(gridData);
    }, [gridData]);

    const LoadBusiessReviewCodes = async () => {
        // debugger;
        setLoading(true);
        const bussrevUrl = `${configData.BASE_APP_URL}CustomerSetup/GetLeadBusinessReview`;
        await fetch(bussrevUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                let typeOptions = [];
                resp.map(bussrev => {
                    const ser = {
                        "name": bussrev.codeDesc,
                        "value": bussrev.codeID
                    }
                    typeOptions = [...typeOptions, ser];
                })
                const defaultBussrev = {
                    "name": "--Select A Value--",
                    "value": ""
                }
                typeOptions.unshift(defaultBussrev);
                setBussreviewOptions(typeOptions)

            })
        setLoading(false);
    };

    const LoadFrequency = async () => {
        // debugger;
        setLoading(true);
        const frequencyUrl = `${configData.BASE_APP_URL}CustomerSetup/GetFrequency`;
        await fetch(frequencyUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                let typeOptions = [];
                resp.map(frequency => {
                    const ser = {
                        "name": frequency.codeDesc,
                        "value": frequency.codeID
                    }
                    typeOptions = [...typeOptions, ser];
                })
                const defaultFrequency = {
                    "name": "--Select A Value--",
                    "value": ""
                }
                typeOptions.unshift(defaultFrequency);
                setFrequencyOptions(typeOptions)

            })
        setLoading(false);
    };

    const LoadCustomerStatisfactionRanking = async () => {
        // debugger;
        setLoading(true);
        const rankingUrl = `${configData.BASE_APP_URL}CustomerSetup/GetCustomerSatisfactionRank`;
        await fetch(rankingUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                let typeOptions = [];
                resp.map(ranking => {
                    const ser = {
                        "name": ranking.codeDesc,
                        "value": ranking.codeID
                    }
                    typeOptions = [...typeOptions, ser];
                })
                const defaultRanking = {
                    "name": "--Select A Value--",
                    "value": ""
                }
                typeOptions.unshift(defaultRanking);
                setRankingOptions(typeOptions)

            })
        setLoading(false);
    };

    const LoadNewBusinessOppurtunities = async () => {
        // debugger;
        setLoading(true);
        const newbusinessUrl = `${configData.BASE_APP_URL}CustomerSetup/GetNewBusinessOpportunities`;
        await fetch(newbusinessUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                let typeOptions = [];
                resp.map(newbusiness => {
                    const ser = {
                        "name": newbusiness.codeDesc,
                        "value": newbusiness.codeID
                    }
                    typeOptions = [...typeOptions, ser];
                })
                const defaultNewBusiness = {
                    "name": "--Select A Value--",
                    "value": ""
                }
                typeOptions.unshift(defaultNewBusiness);
                setNewBusinessOptions(typeOptions)

            })
        setLoading(false);
    };

    const handleReviewCodeChange = (newValue, row) => {
        debugger;
        const selectedService = bussreviewOptions.find(option => option.value === newValue);

        if (selectedService) {
            setGridData(prevGridData => {
                const updatedData = prevGridData.map(item => {
                    if (item.id === row.id) {
                        debugger;
                        const isServiceChanged = item.leadBusinessReview !== selectedService.value;
                        let dirtyFlag = item.dirtyFlag;

                        if (row.isNew && isServiceChanged) {
                            dirtyFlag = 'I';
                        } else if (isServiceChanged) {
                            dirtyFlag = 'U';
                        }

                        return {
                            ...item,
                            leadBusinessReview: selectedService.value,
                            leadBusinessReviewDesc: selectedService.name,
                            dirtyFlag: dirtyFlag,
                            modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username') // Update modifiedBy for existing rows
                            // modifiedOn: item.isNew ? '' : new Date().toISOString() // Update modifiedOn for existing rows
                        };
                    }
                    return item; // Only update the specific row, leave others unchanged
                });
                // debugger;
                onUpdateGridData(updatedData); // Update data immediately
                return updatedData;
            });
        }
    };

    const handleFrequencyChange = (newValue, row) => {
        debugger;

        // tableRef.current.(rowindex, columnindex);

        const selectedService = frequencyOptions.find(option => option.value === newValue);
        let lastReviewDate = new Date(row.lastReviewDate); 
        let nextReviewDate = new Date(row.nextReviewDate);
        if (newValue.length > 0) {
            switch (newValue.toUpperCase()) {
                case 'MONT':
                    const renewTermMonthly = 1; // Monthly renewal term
                    // Calculate next review date for the monthly case
                    nextReviewDate = new Date(lastReviewDate.getFullYear(), lastReviewDate.getMonth() + renewTermMonthly, lastReviewDate.getDate());
                    break;
                case 'YEAR':
                    const renewTermYearly = 1; // Annual renewal term
                    // Calculate next review date for the "Once Per Year" case
                    nextReviewDate = new Date(lastReviewDate.getFullYear() + renewTermYearly, lastReviewDate.getMonth(), lastReviewDate.getDate());
                    break;
                // Add more cases as needed
                case 'QUAR':
                    const renewTermQuarterly = 3; // Quarterly renewal term
                    // Calculate next review date for the "Quarterly" case
                    nextReviewDate = new Date(lastReviewDate.getFullYear(), lastReviewDate.getMonth() + renewTermQuarterly, lastReviewDate.getDate());
                    break;
                case 'TWIY':
                    const renewTermTwiceYearly = 6; // Twice Yearly renewal term
                    // Calculate next review date for the "Twice Yearly" case
                    nextReviewDate = new Date(lastReviewDate.getFullYear(), lastReviewDate.getMonth() + renewTermTwiceYearly, lastReviewDate.getDate());
                    break;
                // Add more cases as needed
                default:
                    // Default behavior if none of the cases match
                    break;
            }
        }

        if (selectedService) {
            setGridData(prevGridData => {
                const updatedData = prevGridData.map(item => {
                    if (item.id === row.id) {
                        debugger;
                        const isServiceChanged = item.frequency !== selectedService.value;
                        let dirtyFlag = item.dirtyFlag;

                        if (row.isNew && isServiceChanged) {
                            dirtyFlag = 'I';
                        } else if (isServiceChanged) {
                            dirtyFlag = 'U';
                        }

                        return {
                            ...item,
                            frequency: selectedService.value,
                            frequencyDesc: selectedService.name,
                            nextReviewDateValue: row.lastReviewDate !== null && newValue !== "" ?  nextReviewDate : null,
                            nextReviewDate: row.lastReviewDate !== null && newValue !== "" ?  formatInputDate(nextReviewDate) : null,
                            // nextReviewDate: row.lastReviewDate !== null && newValue !== "" ? moment(nextReviewDate).format().substring(0, 10): null,
                            dirtyFlag: dirtyFlag,
                            modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username') // Update modifiedBy for existing rows
                            // modifiedOn: item.isNew ? '' : new Date().toISOString() // Update modifiedOn for existing rows
                        };
                    }
                    return item; // Only update the specific row, leave others unchanged
                });
                // debugger;
                onUpdateGridData(updatedData); // Update data immediately
                return updatedData;
            });
        }

    };

    const handleRankingChange = (newValue, row) => {
        debugger;
        const selectedService = rankingOptions.find(option => option.value === newValue);

        if (selectedService) {
            setGridData(prevGridData => {
                const updatedData = prevGridData.map(item => {
                    if (item.id === row.id) {
                        debugger;
                        const isServiceChanged = item.customerSatisfactionRanking !== selectedService.value;
                        let dirtyFlag = item.dirtyFlag;

                        if (row.isNew && isServiceChanged) {
                            dirtyFlag = 'I';
                        } else if (isServiceChanged) {
                            dirtyFlag = 'U';
                        }

                        return {
                            ...item,
                            customerSatisfactionRanking: selectedService.value,
                            customerSatisfactionRankingDesc: selectedService.name,
                            dirtyFlag: dirtyFlag,
                            modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username') // Update modifiedBy for existing rows
                            // modifiedOn: item.isNew ? '' : new Date().toISOString() // Update modifiedOn for existing rows
                        };
                    }
                    return item; // Only update the specific row, leave others unchanged
                });
                // debugger;
                onUpdateGridData(updatedData); // Update data immediately
                return updatedData;
            });
        }
    };

    const handleNewBusinessChange = (newValue, row) => {
        debugger;
        const selectedService = newbusinessOptions.find(option => option.value === newValue);

        if (selectedService) {
            setGridData(prevGridData => {
                const updatedData = prevGridData.map(item => {
                    if (item.id === row.id) {
                        debugger;
                        const isServiceChanged = item.newBusinessOpportunities !== selectedService.value;
                        let dirtyFlag = item.dirtyFlag;

                        if (row.isNew && isServiceChanged) {
                            dirtyFlag = 'I';
                        } else if (isServiceChanged) {
                            dirtyFlag = 'U';
                        }

                        return {
                            ...item,
                            newBusinessOpportunities: selectedService.value,
                            newBusinessOpportunitiesDesc: selectedService.name,
                            dirtyFlag: dirtyFlag,
                            modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username') // Update modifiedBy for existing rows
                            // modifiedOn: item.isNew ? '' : new Date().toISOString() // Update modifiedOn for existing rows
                        };
                    }
                    return item; // Only update the specific row, leave others unchanged
                });
                // debugger;
                onUpdateGridData(updatedData); // Update data immediately
                return updatedData;
            });
        }
    };

    const handleLastReviewDateChange = (newDate, row) => {
        debugger;
        let lastReviewDate = new Date(newDate); 
        let nextReviewDate = new Date(row.nextReviewDate);
        if (row.frequency.length > 0) {
            switch (row.frequency.toUpperCase()) {
                case 'MONT':
                    const renewTermMonthly = 1; // Monthly renewal term
                    // Calculate next review date for the monthly case
                    nextReviewDate = new Date(lastReviewDate.getFullYear(), lastReviewDate.getMonth() + renewTermMonthly, lastReviewDate.getDate());
                    break;
                case 'YEAR':
                    const renewTermYearly = 1; // Annual renewal term
                    // Calculate next review date for the "Once Per Year" case
                    nextReviewDate = new Date(lastReviewDate.getFullYear() + renewTermYearly, lastReviewDate.getMonth(), lastReviewDate.getDate());
                    break;
                // Add more cases as needed
                case 'QUAR':
                    const renewTermQuarterly = 3; // Quarterly renewal term
                    // Calculate next review date for the "Quarterly" case
                    nextReviewDate = new Date(lastReviewDate.getFullYear(), lastReviewDate.getMonth() + renewTermQuarterly, lastReviewDate.getDate());
                    break;
                case 'TWIY':
                    const renewTermTwiceYearly = 6; // Twice Yearly renewal term
                    // Calculate next review date for the "Twice Yearly" case
                    nextReviewDate = new Date(lastReviewDate.getFullYear(), lastReviewDate.getMonth() + renewTermTwiceYearly, lastReviewDate.getDate());
                    break;
                // Add more cases as needed
                default:
                    // Default behavior if none of the cases match
                    break;
            }
        }

        const updatedData = gridData.map(item => {
            if (item.id === row.id) {

                // Check if newDate is null
                const isDateChanged = newDate !== null && item.lastReviewDate !== moment(newDate).format().substring(0, 10);

                let dirtyFlag = item.dirtyFlag;

                if (row.isNew && isDateChanged) {
                    dirtyFlag = 'I';
                } else if (isDateChanged) {
                    dirtyFlag = 'U';
                }
                return {
                    ...item,
                    // lastReviewDate: newDate !== null ? moment(newDate).format().substring(0, 10) : null,
                    // nextReviewDate: row.frequency !== "" &&  newDate !== null ? moment(nextReviewDate).format().substring(0, 10) : null,
                    lastReviewDateValue: newDate, 
                    lastReviewDate: formatInputDate(newDate),
                    nextReviewDateValue: row.frequency !== "" ?  nextReviewDate : null,
                    nextReviewDate: row.frequency !== "" ?  formatInputDate(nextReviewDate) : null,
                    dirtyFlag: dirtyFlag,
                    modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username') // Update modifiedBy for existing rows
                    // modifiedOn: item.isNew ? '' : new Date().toISOString() // Update modifiedOn for existing rows
                };
            }
            return item;
        });

        // Update data immediately and notify parent component
        setGridData(updatedData);
        onUpdateGridData(updatedData);
    };

    const handleNextReviewDateChange = (newDate, row) => {
        const updatedData = gridData.map(item => {
            if (item.id === row.id) {

                // Check if newDate is null
                const isDateChanged = newDate !== null && item.nextReviewDate !== moment(newDate).format().substring(0, 10);

                let dirtyFlag = item.dirtyFlag;

                if (row.isNew && isDateChanged) {
                    dirtyFlag = 'I';
                } else if (isDateChanged) {
                    dirtyFlag = 'U';
                }
                return {
                    ...item,
                    // nextReviewDate: newDate !== null ? moment(newDate).format().substring(0, 10) : null,
                    nextReviewDateValue: newDate,
                    nextReviewDate: formatInputDate(newDate),
                    dirtyFlag: dirtyFlag,
                    modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username') // Update modifiedBy for existing rows
                    // modifiedOn: item.isNew ? '' : new Date().toISOString() // Update modifiedOn for existing rows
                };
            }
            return item;
        });

        // Update data immediately and notify parent component
        setGridData(updatedData);
        onUpdateGridData(updatedData);
    };

    const handleRegionTextChange = (newValue, row) => {
        const updatedData = gridData.map(item => {
            if (item.id === row.id) {
                const isTextChanged = item.region !== newValue;

                let dirtyFlag = item.dirtyFlag;

                if (row.isNew && isTextChanged) {
                    dirtyFlag = 'I';
                } else if (isTextChanged) {
                    dirtyFlag = 'U';
                }

                return {
                    ...item,
                    region: newValue,
                    dirtyFlag: dirtyFlag,
                    modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username') // Update modifiedBy for existing rows
                    // modifiedOn: item.isNew ? '' : new Date().toISOString() // Update modifiedOn for existing rows
                };
            }
            return item;
        });

        // Update data immediately and notify parent component
        setGridData(updatedData);
        onUpdateGridData(updatedData);
    };

    const handleNotesTextChange = (newValue, row) => {
        const updatedData = gridData.map(item => {
            if (item.id === row.id) {
                const isTextChanged = item.comments !== newValue;

                let dirtyFlag = item.dirtyFlag;

                if (row.isNew && isTextChanged) {
                    dirtyFlag = 'I';
                } else if (isTextChanged) {
                    dirtyFlag = 'U';
                }

                return {
                    ...item,
                    comments: newValue,
                    dirtyFlag: dirtyFlag,
                    modifiedBy: item.isNew ? '' : sessionStorage.getItem('my-username') // Update modifiedBy for existing rows
                    // modifiedOn: item.isNew ? '' : new Date().toISOString() // Update modifiedOn for existing rows
                };
            }
            return item;
        });

        // Update data immediately and notify parent component
        setGridData(updatedData);
        onUpdateGridData(updatedData);
    };

    const handleCheckboxChange = (checked, row) => {
        const updatedData = gridData.map(item => {
            if (item.id === row.id) {
                return { ...item, checked };
            }
            return item;
        });
        setGridData(updatedData);
    };
    const generateNewRow = () => {
        const username = sessionStorage.getItem('my-username');
        const timestamp = new Date().getTime().toString(); // Use current timestamp as string

        return {
            id: timestamp, // Unique ID based on timestamp
            checked: false,
            customerKey: cust,
            serviceType: "BR",
            region: "",
            leadBusinessReview: "",
            leadBusinessReviewDesc: '--Select A Value--',
            frequency: "",
            frequencyDesc: '--Select A Value--',
            lastReviewDateValue: null,
            lastReviewDate: null,
            nextReviewDateValue: null,
            nextReviewDate: null,
            customerSatisfactionRanking: "",
            customerSatisfactionRankingDesc: '--Select A Value--',
            newBusinessOpportunities: "",
            newBusinessOpportunitiesDesc: '--Select A Value--',
            comments: "",
            createdBy: username,
            // createdOn: new Date().toISOString(),
            dirtyFlag: 'I',
            isNew: true
        };
    };

    const handleAddRow = () => {
        const newRow = generateNewRow();
        setGridData([...gridData, newRow]);
    };

    const handleDeleteRows = async () => {
        // Get the IDs of rows to be deleted
        debugger;
        const selectedRowIds = gridData.filter(row => row.checked && !row.isNew).map(row => row.id);

        if (selectedRowIds.length === 0) {
            // If no rows are selected for deletion, return early
            const updatedData = gridData.filter(row => !row.checked);
            setGridData(updatedData);
            onUpdateGridData(updatedData);
            const deletedRowCount = selectedRowIds.length;
            onDeleteRows(deletedRowCount);
            return;
        }

        // Prepare the request URL with customer_key and comma-separated IDs
        const customerKey = cust; // Use the 'cust' state for customer_key
        const idsToDelete = selectedRowIds.join(',');

        const apiUrl = `${configData.BASE_APP_URL}CustomerSetup/DeleteVolumeByCustomer?customerkey=${customerKey}&ids=${idsToDelete}`;

        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            });

            if (response.ok) {
                // Delete was successful, update the state and notify parent component
                window.alert('Data deleted successfully.');
                const updatedData = gridData.filter(row => !row.checked);
                setGridData(updatedData);
                onUpdateGridData(updatedData);
                const deletedRowCount = selectedRowIds.length;
                onDeleteRows(deletedRowCount);
                // window.confirm('Data deleted successfully.');
            } else {
                // Handle error response from the API if needed
                console.error('Error deleting rows:', response.statusText);
                window.alert('Error deleting data.');
            }
        } catch (error) {
            // Handle network or other errors if needed
            console.error('Error deleting rows:', error);
            window.alert('Error deleting data.');
        }
    };

    function formatDateTime(dateTime) {
        if (dateTime) {
            return new Date(dateTime).toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: true,
                timeZone: 'UTC'
            });
        }
        return '';
    }

    return (
        <div className="accordion-item">
            <h2 className="accordion-header" id="headingSeven">
                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeven" aria-expanded="true" aria-controls="collapseSeven">
                    Business Review
                </button>
            </h2>
            <div id="collapseSeven" className="accordion-collapse collapse show" aria-labelledby="headingSeven" data-bs-parent="#accordionSettings">
                <div className="accordion-body">

                    <div className='custom-table-text accordian-table'>
                        <button className='btn btn-filter mb-2' onClick={handleAddRow}> <i className='fa fa-plus'></i> Add</button>
                        <button className='btn btn-clear ms-2 mb-2' onClick={handleDeleteRows}> <i className='fa fa-trash'></i> Delete</button>
                        <div className='react-bootstrap-table'>
                            <table className='table table-striped table-hover'>
                                <thead>
                                    <tr className='table-top'>
                                        <th className='center-align' width='30px'></th>
                                        <th className='center-align' width='200px'>Region</th>
                                        <th className='center-align' width='250px'>Lead Business Reviews</th>
                                        <th className='center-align' width='200px'>Frequency</th>
                                        <th className='center-align' width='120px'>Last Review Date</th>
                                        <th className='center-align' width='120px'>Next Review Date</th>
                                        <th className='center-align' width='150px'>Customer Satisfaction Ranking</th>
                                        <th className='center-align' width='150px'>New Business Opportunities?</th>
                                        <th className='center-align' width='150px'>Notes</th>
                                        <th className='center-align' width='100px'>Created By</th>
                                        <th className='center-align' width='100px'>Created On</th>
                                        <th className='center-align' width='100px'>Modified By</th>
                                        <th className='center-align' width='100px'>Modified On</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {gridData.map((row, index) => (
                                        <tr
                                            key={row.id}
                                        >
                                            <td className='center-align'>
                                                <input
                                                    type='checkbox'
                                                    checked={row.checked}
                                                    onChange={e => handleCheckboxChange(e.target.checked, row)}
                                                />
                                            </td>
                                            <td className='center-align'>
                                                <textarea
                                                    rows="2"
                                                    value={row.region}
                                                    onChange={e => handleRegionTextChange(e.target.value, row)}
                                                />
                                            </td>
                                            <td className='center-align'>
                                                <SelectSearch
                                                    id="ddnReview"
                                                    name="ddnReview"
                                                    className="select-search"
                                                    value={row.leadBusinessReview}
                                                    options={bussreviewOptions}
                                                    onChange={newValue => handleReviewCodeChange(newValue, row)}
                                                    search
                                                    filterOptions={fuzzySearch}

                                                >
                                                </SelectSearch>
                                            </td>
                                            <td className='center-align'>
                                                <SelectSearch
                                                    id="ddnFrequency"
                                                    name="ddnFrequency"
                                                    className="select-search"
                                                    value={row.frequency}
                                                    options={frequencyOptions}
                                                    onChange={newValue => handleFrequencyChange(newValue, row)}
                                                    search
                                                    filterOptions={fuzzySearch}

                                                >
                                                </SelectSearch>
                                            </td>
                                            <td className='center-align'>
                                                <DatePicker
                                                    // value={row.lastReviewDate !== null ? new Date(row.lastReviewDate) : null}
                                                    value={row.lastReviewDateValue}
                                                    onChange={newDate => handleLastReviewDateChange(newDate, row)}
                                                    calendarIcon={<i className='fas fa-calendar-alt'></i>}
                                                    format='MM/dd/yyyy'
                                                    fixedHeight
                                                    openCalendarOnFocus={false}
                                                />
                                            </td>
                                            <td className='center-align'>
                                                <DatePicker
                                                    // value={row.nextReviewDate !== null ? new Date(row.nextReviewDate) : null}
                                                    value={row.nextReviewDateValue}
                                                    onChange={newDate => handleNextReviewDateChange(newDate, row)}
                                                    calendarIcon={<i className='fas fa-calendar-alt'></i>}
                                                    format='MM/dd/yyyy'
                                                    fixedHeight
                                                    openCalendarOnFocus={false}
                                                />
                                            </td>
                                            <td className='center-align'>
                                                <SelectSearch
                                                    id="ddnSatisfaction"
                                                    name="ddnSatisfaction"
                                                    className="select-search"
                                                    value={row.customerSatisfactionRanking}
                                                    options={rankingOptions}
                                                    onChange={newValue => handleRankingChange(newValue, row)}
                                                    search
                                                    filterOptions={fuzzySearch}
                                                >
                                                </SelectSearch>
                                            </td>
                                            <td className='center-align'>
                                                <SelectSearch
                                                    id="ddnNewBusiness"
                                                    name="ddnNewBusiness"
                                                    className="select-search"
                                                    value={row.newBusinessOpportunities}
                                                    options={newbusinessOptions}
                                                    onChange={newValue => handleNewBusinessChange(newValue, row)}
                                                    search
                                                    filterOptions={fuzzySearch}
                                                >
                                                </SelectSearch>
                                            </td>
                                            <td className='center-align'>
                                                <textarea
                                                    rows="2"
                                                    value={row.comments}
                                                    onChange={e => handleNotesTextChange(e.target.value, row)}
                                                />
                                            </td>
                                            <td className='center-align'>{row.createdBy ? row.createdBy.toUpperCase() : ''}</td>
                                            <td className='center-align'>{formatDateTime(row.createdOn)}</td>
                                            <td className='center-align'>{row.modifiedBy ? row.modifiedBy.toUpperCase() : ''}</td>
                                            <td className='center-align'>{formatDateTime(row.modifiedOn)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

